export default (to) => {
  if (process.env.NODE_ENV === 'development'){
    console.log("middleware:log: " + to.name);
  }
}
